import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import {DataService, OperationsService, StorageService} from '../../_services';
import {ToastrService} from 'ngx-toastr';
@Component({
  selector: 'app-newaccount',
  templateUrl: './newaccount.component.html',
  styleUrls: ['./newaccount.component.css']
})
export class NewaccountComponent implements OnInit {

  @Input('loading') loading = false;
  @Input('banks') banks: any;
  @Input('showForm') showForm = false;
  @Input('showSearch') showSearch = false;
  @Input('nigerian_banks') nigerian_banks: any;
  @Input('VERIFY_STATUS') VERIFY_STATUS = false;
  @Input('charge_account') charge_account = false;
  @Input('destination') destination = false;
  @Input('fresponse') fresponse;
  @Input('confirming') confirming = true;
  @Input('types') types = true;
  @Input('parents') parents = true;
  @Input('otpConfirmed') otpConfirmed = false;
  @Input('otpHBSFC') otpHBSFC = false;
  @Input('confirmingOTP') confirmingOTP = true;
  @Input('lenderbanksaved') lenderbanksaved = false;
  @Input('lbHBSFS') lbHBSFS = false;
  @Input('account') account = { GL_PARENT: '', GL_NAME: '', GL_CATEGORY: '0', GL_TYPE: '0' };
  @Input('accounts_created') accounts_created;
  @Input('local_accounts') local_accounts;
  @Input('overlayWithdrawal') overlayWithdrawal;
  accounts:any;
  newAccountForm: FormGroup;
  currentUser: any;
  group: string;
  groups: any[];
  GL_NAME: any;
  GL_PARENT: any;
  categories = [
    {
      'value': '2', 'display': 'Leaf'
    },
    {
      'value': '1', 'display': 'Node'
    }
  ];
  report_code = [
    {
      'value': '1', 'display': 'Trial Balance', 'checked': false
    },
    {
      'value': '2', 'display': 'Balance Sheet', 'checked': false
    }
  ];
  excludes = [
    {
      'value': '1', 'display': 'Trial Balance', 'checked': false
    },
    {
      'value': '2', 'display': 'Balance Sheet', 'checked': false
    },
    {
      'value': '3', 'display': 'Profit and Loss', 'checked': false
    }
  ];
  @Output() saveTheLenderAccount = new EventEmitter();
  @Output() addTheNewAccount = new EventEmitter();
  account_group;
  constructor(public fb: FormBuilder, private operationsService: OperationsService, private storageService: StorageService, private toastr: ToastrService, private dataService: DataService
  ) {
    this.newAccountForm = fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.
      'GL_CATEGORY': [{disabled: true}, Validators.required],
      'GL_PARENT': [{disabled: true}],
      'ACCOUNTS': [null],
      // 'GL_TYPE': [null, Validators.required],
     'ACCOUNT_ID': [null],
      'GL_NAME': [null, Validators.required],
      'GL_GROUP': [null],
      'GL_GROUPS': [null],
      'DESCRIPTION': [null],
      // 'GL_PARENT': [null, Validators.required],
    });
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {

  }
  filterTheGlobalAccounts(event){
    console.log(this.accounts_created)
    this.accounts = this.accounts_created.filter(function (res) {
      return res.GL_CATEGORY == event.target.value;
    });
  }
  // addNewAccount(value) {
  //   this.accounts_created.GL_CATEGORY = value.GL_CATEGORY;
  //   this.accounts_created.GL_NAME = value.GL_NAME;
  //   this.addTheNewAccount.emit();
  // }
  showSuccess(message) {
    return this.toastr.success(message, 'Success');
  }
  showError(message) {
    return this.toastr.error(message, 'Error');
  }
  saveLenderAccount(value) {
    this.account.GL_CATEGORY = value.GL_CATEGORY;
    this.account.GL_PARENT = value.GL_PARENT;
    this.account.GL_NAME = value.GL_NAME;
    this.account.GL_TYPE = value.GL_TYPE;
    this.saveTheLenderAccount.emit();
  }
  selectTheDefaultAccount(event) {
    (<FormControl>this.newAccountForm.controls['GL_NAME'])
      .setValue(event.GL_NAME, { onlySelf: true });
    (<FormControl>this.newAccountForm.controls['GL_CATEGORY'])
      .setValue(event.GL_CATEGORY, { onlySelf: true });
    (<FormControl>this.newAccountForm.controls['ACCOUNT_ID'])
      .setValue(event.ACCOUNT_ID, { onlySelf: true });
    // (<FormControl>this.newAccountForm.controls['ACCOUNT_ID'])
    //   .setValue(event.ACCOUNT_ID, { onlySelf: true });
  }
  selectGroup(event) {
    this.group = event.target.value;
    return this.operationsService.getAccountGroups(this.currentUser.token, this.group).subscribe(data => {
      this.groups = data.groups;
    }, () => {
      this.showError('An error occurred');
    });
  }
  addNewAccount(value) {
    this.loading = true;
    return this.operationsService.addNewAccount(this.currentUser.token, value.ACCOUNTS.ACCOUNT_ID, this.GL_NAME, this.account_group, this.group, this.GL_PARENT).subscribe(res => {
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.response);
        this.dataService.refreshPage.emit({overlayWithdrawal: false});
      } else {
        this.loading = false;
        this.showSuccess(res.response);
      }
    }, () => {
      this.loading = false;
      this.showError('An error occurred, try again');
    });
  }
}
